import { FaExclamationTriangle } from "react-icons/fa";
import { Box } from "@mui/system";
import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 400,
    minWidth: 300,
    bgcolor: "white",
    boxShadow: 24,
    p: 4,
    borderRadius: 5,
};

const NoPlanModel = ({ open, onClose }) => {
    const { t } = useTranslation("add_guest");
    const navigate = useNavigate();

    const onConfirm = () => {
        navigate('/Rate');
    }

    return (
        <Modal
            disableScrollLock={true}
            open={open}
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            disableEscapeKeyDown={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <center>
                    <div className="icon-div">
                        <FaExclamationTriangle size={50} className="text-[#3686FF]" />
                    </div>
                    <div className="py-4">
                        <span className="font-bold text-[20px] text-[#3686FF]">
                            {t('no_active_plan')}
                        </span>
                    </div>
                    <span className="text-gray-500 font-semibold">
                        {t('no_active_plan_msg')}
                    </span>
                    <div className="flex gap-3 justify-center pt-4">
                        <button
                            onClick={() => {
                                onConfirm();
                                onClose();
                            }}
                            className="flex-1 px-4 py-2 text-white bg-[#3686FF] rounded-lg transition-colors whitespace-normal"
                        >
                            {t('btn_purchase')}
                        </button>
                    </div>
                </center>
            </Box>
        </Modal>

    );
};

export default NoPlanModel;
